export const devProcessParagraphs = [
    {
        id: 1,
        title: "Initial consultation",
        description:
            "We have an initial meeting with the client to discuss their requirements, goals, and vision for their website or web application. We gather information about their target audience, brand identity, and any specific features or functionalities they need.",
    },
    {
        id: 2,
        title: "Discovery Phase",
        description:
            "Based on the initial consultation, we prepare a detailed proposal that outlines the scope of work, timeline, and cost of the project. We also provide information on the technology stack we plan to use and the deliverables we will provide.",
    },
    {
        id: 3,
        title: "Design",
        description:
            "Once the proposal is approved, we begin the design phase. Our team creates wireframes and mockups of the website or application to give the client an idea of how it will look and function. We collaborate with the client to refine the design until they are satisfied.",
    },
    {
        id: 4,
        title: "Development",
        description:
            "After the design is approved, we move on to the development phase. Our developers write the code using the selected technology stack, integrating all the required features and functionalities. We conduct regular testing to ensure that the website or application works smoothly and is fully functional.",
    },
    {
        id: 5,
        title: "Testing and quality assurance",
        description: `Before launching the website or application, we conduct rigorous testing and quality assurance to ensure that it meets the client's requirements and is free of errors or bugs.`,
    },
    {
        id: 6,
        title: "Launch",
        description:
            "Once the website or application is approved, we launch it and make it available to the public. We also provide ongoing maintenance and technical support to ensure that the website or application is always up-to-date and fully functional.",
    },
];
